
    import { Vue,Component } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import PagedTable from '../../components/common/pagedTable.vue'
    import Partner from '../../components/partner.vue'
    import exicon from '../../assets/expressicon'
    const mail = namespace('mail') //getMailList
    const site = namespace('site') 
    const templateURL = 'http://cloudprint.cainiao.com/template/standard/310941/8';
    @Component({
        components: {
            PagedTable,
            Partner
        }
    })
    export default class Home extends Vue{
        exicon:any = exicon
        daterange:any = [] //入库时间断
        pachagesInfo:Boolean = false //快递订单详情弹窗
        orderInfo:any = null //快递订单详情
        tbform:any  = {}
        rowEdit:boolean = true
        printers = []
        codeprinter = window.localStorage.getItem('printer');
        page:number = 1
        printNum = 10
        printerDialog = false
        printerShow = false
        orientation = 1
        printerId = ''
        socket = null
        UUID = []
        printer = {
          version: '1.0', // 协议版本
          errMsg: '等待初始化',
          printerList: [], // 打印机列表
          printerDate: [], // 需要打印的数据
        }
        printerConfig = {
          name: 'printer', // 默认打印机
          paperSize: {
            width: 1,
            height: 1,
          },
        }
        printerPartnerId:string = '' //选择打印面单的合作快递员id


        @mail.State('pager') pager:any //表格的页码
        @mail.State('list') pagerList:any //快递员列表
        @mail.State('loading') loading:any
        @site.State('info') info:any
        @site.State('printList') printList:any //合作寄件快递员列表
        @site.Getter('eorderNum') eorderNum:number
        @site.Action('getPrintList') getPrintList: any
        search = {
            code: '',
            phone: '',
            partner: '',
            pageSize: 20,
        }
        get searchQuery() {
            const { code, phone, partner, pageSize } = this.search;
            if(this.daterange){
                return {
                    code,
                    phone,
                    partner,
                    star: this.daterange[0],
                    end: this.daterange[1],
                    page: this.page,
                    pageSize,
                }
            }else{
               return {
                    code,
                    phone,
                    partner,
                    star: '',
                    end: '',
                    page: this.page,
                    pageSize,
                } 
            }
        }
        get exportDisabled(){
            return !this.searchQuery.star || !this.searchQuery.end;
        }
        get tablecolumn(){
            return [
                {
                    prop: 'serial',
                    name: 'serial',
                    type: 'slot',
                    label: '编号',
                },
                {
                    prop: 'Sender',
                    name: 'Sender',
                    type: 'slot',
                    label: '寄件人',
                },
                {
                    prop: 'Receiver',
                    name: 'Receiver',
                    type: 'slot',
                    label: '收件人',
                },
                {
                    prop: 'partner',
                    name: 'partner',
                    type: 'slot',
                    label: '快递单位',
                },
                {
                    prop: 'codeStr',
                    name: 'code',
                    type: 'slot',
                    width: '120px',
                    label: '快递单号',
                },
                {
                    prop: 'GoodsWeight',
                    type: 'slot',
                    name: 'weight',
                    label: '量(KG)',
                },
                {
                    prop: 'money',
                    type: 'slot',
                    name: 'money',
                    label: '费用',
                },
                {
                    prop: 'cost',
                    type: 'slot',
                    name: 'cost',
                    label: '价格',
                },
                {
                    prop: 'profit',
                    type: 'text',
                    label: '差价',
                },
                {
                    prop: 'desc',
                    type: 'slot',
                    name: 'desc',
                    label: '备注',
                },
                {
                    prop: 'ctime',
                    type: 'text',
                    width: '170px',
                    label: '创建时间',
                },
                {
                    prop: 'name',
                    name:'operation',
                    fixed: 'right',
                    type: 'slot',
                    label: '操作',
                    width: '220px'
                }
            ]
        }
        @mail.Action('getMailList') getMailList:any
        @mail.Action('deleteMail') deleteMail:any
        @mail.Action('editMail') editMail:any
        @mail.Action('getMailDetail') getMailDetail:any
        @mail.Mutation('changeExEdit') changeExEdit:any
        @mail.Action('printMail') printMail:any
        @mail.Action('recordPrinter') recordPrinter:any
        created(){
            this.getPrintList();
            this.socket = new WebSocket(process.env.VUE_APP_PRINTERURL);
            this.socket.onopen = () => {
                this.socket.onmessage = (event) => {
                console.log('监听到一条消息, data:', event.data);
                const response = JSON.parse(event.data);
                if (response.status === 'success' || response.taskStatus === 'printed') {
                    switch (response.cmd) {
                    case 'getAgentInfo':
                        // 获取打印机列表
                        return this.socket.send(JSON.stringify(this.getDefaultRequest('getPrinters', response.requestID)));
                    // 获取打印机版本
                    case 'getPrinters':
                        // 获取打印机列表 并解析打印机列表数据
                        if (response.printers.length) {
                        // 获取默认打印机的配置
                        const p = this.printer.printerList;
                        response.printers.forEach((pt) => {
                            console.log(response.defaultPrinter);
                            pt.status === 'enable' && p.push(pt.name);
                            if (response.defaultPrinter) {
                                // this.printerConfig.name = response.defaultPrinter;
                                const printer = localStorage.getItem("printer");
                                if(printer){
                                    console.log(printer+'ZAJ');
                                    this.printerConfig.name = printer;
                                }
                            }
                        });
                        } else {
                        this.printer.errMsg = '无可用的打印机!';
                        }
                        break;
                    case 'getPrinterConfig':
                        // 获取某个打印机的设置参数
                        break;
                    case 'setPrinterConfig':
                        this.resolve_setPrinterConfig && this.resolve_setPrinterConfig('setPrinterConfig');
                        break;
                    case 'notifyPrintResult':
                        // 打印结果通知协议
                        if (response.taskStatus === 'printed') {
                        // 已经打印完成
                        } else if (response.taskStatus === 'rendered') {
                        // 已经渲染完成
                        }
                        break;
                    case 'print':
                        // 打印
                        if (response.previewURL || response.previewImage) {
                        console.log('打印成功:', response);
                        }
                        break;
                    default:
                    }
                } else {
                    if (response.cmd === 'notifyPrintResult') {


                    } else {
                        this.printer.errMsg = response.msg;
                    }
                    console.log(response)
//                    this.$monitor.push({
//                        title: `打印错误信息${response.msg}`,
//                        info: JSON.stringify(response),
//                    });
                }
                };
                this.socket.onclose = () => {
                this.printer.errMsg = '菜鸟打印组件连接断开！';
                };
                // 先获取版本
                this.socket.send(JSON.stringify(this.getDefaultRequest('getAgentInfo')));
                this.printer.errMsg = '';
            };
            console.log();
            if(this.info.cainiaoToken){
                this.socket.onerror = () => {
                    this.$notify.error({
                    title: '系统错误',
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: `<div class="print_info">亲，系统检测到菜鸟打印组件启动失败，解决办法：
                                    <h3>1、未安装控件</h3>
                                    <p>请先安装控件，<a href="http://cloudprint.cainiao.com/cloudprint/client/CNPrintSetup.exe" target="_blank">请点击此处下载</a>。安装好后重启浏览器即可。</p>
                                    <h3>2、已安装控件</h3>
                                    <p>请在电脑的开始菜单-->“所有程序”里找到“CAINIAO打印组件”进行启动。</p></div>`,
                    });
                    this.printer.errMsg = '连接打印组件失败！';
                };
            }
        }
        mounted(){
            this.getList();
            
        }
        getList(){
            this.getMailList(this.searchQuery)
        }
        // 删除寄件
        deleteRow(id:string){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', { confirmButtonText: '确定',  cancelButtonText: '取消', type: 'warning'}).then(async () => {
                const res = await this.deleteMail(id)
                if(res){
                    this.$message({ message: '删除成功', type: 'success' });
                    this.getList()
                }
            }).catch();
            
        }
        // 编辑寄件
        edit(id:string){
            this.$router.push(`/mail/edit?id=${id}`)
        }
        // 添加寄件
        add(){
            this.$router.push('/mail/add')
        }
        // 快递员改变
        partnerChange(e:any){
            console.log(e);
            this.search.partner = e;
        }
        // 查看快递详情
        async lookDetail(id:string){
            this.pachagesInfo = true;
            const res = await this.getMailDetail(id);
            this.orderInfo = res;
        }
        // 翻页
        pagechange(e:any){
            this.page = e[0].val;
            this.getList();
        }
        // 条数改变
        pageSizechange(e:any){
            this.search.pageSize = e[0].val;
            this.getList();
        }
        cellMouseEnter(row, column, cell, event){
            const index = row.index;
            this.changeExEdit({index, value:true});
        }
        cellMouseLeave(row, column, cell, event){
            const index = row.index;
            this.changeExEdit({index, value:false});
        }
        async modifyValue(id, key, value){
            if(key && value){
                await this.editMail({
                    id,
                    data:{
                        [key]: value
                    }
                })
                this.$message.success('修改成功');
                this.getList();
            }
        }
        async printRow(id:string,partnerId:string){
            this.printerId = id;
            this.printerShow = true;
            this.printerPartnerId = partnerId ;
            
        }
        print(){
            this.setConfig();
            const docs = this.gendocuments();
            const request = {
                "cmd": "print",
                "requestID": "123458976",
                "version": "1.0",
                "task": {
                    "taskID": this.getUUID(),
                    "preview": false,
                    "printer": this.codeprinter,
                    "previewType": "pdf",
                    "firstDocumentNumber": 10,
                    "totalDocumentCount": 100,
                    documents:docs,
                }
            }
            this.socket.send(JSON.stringify(request))
        }
        gendocuments(){
            const result = [];
            const num = this.printNum;
            const siteid = this.$store.state.baseInfo.userInfo.site;
            for(let i = 0; i < num; i++){
                result.push({
                    "documentID": "0123456789",
                    "contents": [{
                        "data": {
                            waqrcodeUrl: `${process.env.VUE_APP_QRCODEURL}?id=${siteid}`,
                        },
                        templateURL
                    }]
                })
            }
            return result;
        }
        setConfig(){
            this.socket.send(JSON.stringify({
                    "cmd": "setPrinterConfig",
                    "requestID": "123458976",
                    "version": "1.0",
                    "printer": {
                        "name": this.codeprinter,
                        "autoPageSize": true,
                        "orientation": this.orientation,
                        "paperSize": {
                            "width": 40,
                            "height": 30
                        }
                    }
                }
            ))
        }
        exportexcel(){
            const token = window.localStorage.getItem('token');
            const url = process.env.VUE_APP_API;
            const start = this.searchQuery.star;
            const end = this.searchQuery.end;
            const partner = this.searchQuery.partner;
            window.open(`${url}/client/delivery/export/excel?token=${token}&start=${start}&end=${end}&partner=${partner}`);
        }
        async printPackge(){
            window.localStorage.setItem('printer',this.printerConfig.name);
            const res = await this.printMail(this.printerId);
            if(res){
                this.sendPrint(1234567890,res);
                await this.recordPrinter(this.printerId);
                await this.getMailList();
                if(this.eorderNum !== 0 && this.eorderNum -30 < 0){
                    this.$alert('面单数量不足，请及时充值哦！', {
                        confirmButtonText: '确定'
                    });
                }
            }
        }

        // 获取通用请求参数
      getDefaultRequest(cmd, id) {
        return {
          version: this.printer.version,
          cmd,
          requestID: id || this.getUUID(),
        };
      }
      // 获取通用唯一标识符
      getUUID(len = 8) {
        let id;
        do {
          id = Math.random().toString(16).slice(len * -1).toUpperCase();
        } while (this.UUID.includes(id));
        this.UUID.push(id);
        return id;
      }
      // 获取打印机配置
      getPrinterConfig(name) {
        const request = this.getDefaultRequest('getPrinterConfig');
        request.printer = (this.printerConfig.name = name);// 设置默认打印机
        this.socket.send(JSON.stringify(request));
      }
      // 设置打印机配置(每次打印前设置)
      setPrinterConfig(resolve, obj) {
        if (resolve) {
          this.resolve_setPrinterConfig = resolve;
        }
        const request = this.getDefaultRequest('setPrinterConfig', this.getUUID());
        request.printer = Object.assign(this.printerConfig, obj);
        request.printer.paperSize.width >>= 0;
        request.printer.paperSize.height >>= 0;
        this.socket.send(JSON.stringify(request));
      }
      // 请求打印
      sendPrint( orderId, contents, preview = false, type = 'pdf') {
        const request = this.getDefaultRequest('print', this.getUUID());
        const printData = JSON.parse(contents[0].printData).data || JSON.parse(contents[0].printData);
        const contentsa = {
            data:printData,
            templateURL: this.getPrintTemplateUrl(printData.cpCode),
        }
        console.log(contentsa);
        const customArea = contents[0].customArea;
        request.task = {
          previewType: type,
          preview,
          taskID: `${orderId}_${this.getUUID()}`,
          printer: this.printerConfig.name, //this.printerConfig.name
          notifyType: ['print'], // 仅出纸响应
          documents: [{
            documentID: `${orderId}_${this.getUUID()}`,
            contents: [contentsa,customArea]
          }],
        };
          this.socket.send(JSON.stringify({
                  "cmd": "setPrinterConfig",
                  "requestID": "123458976",
                  "version": "1.0",
                  "printer": {
                      "name": this.printerConfig.name,
                      "autoPageSize": true,
                      "orientation": 0,
                      "paperSize": {
                          "width": 40,
                          "height": 30
                      }
                  }
              }
          ))
        this.socket.send(JSON.stringify(request));
        this.$message.success('打印成功');
      }
      // 获取打印模板
      getPrintTemplateUrl(cpCode){
        const newEorderTemplate = this.$store.state.site.info.newEorderTemplate;
        if(!newEorderTemplate) return 'http://cloudprint.cainiao.com/template/standard/282585/3';
        const map = {
            HTKY: 'http://cloudprint.cainiao.com/template/standard/278716/19',
            default: 'http://cloudprint.cainiao.com/template/standard/278716/19',// 未修改
            STO: 'http://cloudprint.cainiao.com/template/standard/288948/25',
            ZTO: 'http://cloudprint.cainiao.com/template/standard/308812/4',
            YUNDA: 'http://cloudprint.cainiao.com/template/standard/288658/9',
            YTO: 'http://cloudprint.cainiao.com/template/standard/290659/22',
        }
        return map[cpCode] || map.default;
      }
    }
